import { render } from "./IncomeExpenseChart.vue?vue&type=template&id=d2d850ca&scoped=true"
import script from "./IncomeExpenseChart.vue?vue&type=script&lang=js"
export * from "./IncomeExpenseChart.vue?vue&type=script&lang=js"

import "./IncomeExpenseChart.vue?vue&type=style&index=0&id=d2d850ca&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d2d850ca"]])

export default __exports__